function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Valid column types to be used for a call to newTable.
 */
export class NewTableColumnTypes {}
_defineProperty(NewTableColumnTypes, "INTEGER", 'int');
_defineProperty(NewTableColumnTypes, "LONG", 'long');
_defineProperty(NewTableColumnTypes, "DOUBLE", 'double');
_defineProperty(NewTableColumnTypes, "BOOLEAN", 'bool');
_defineProperty(NewTableColumnTypes, "STRING", 'string');
_defineProperty(NewTableColumnTypes, "DATE_TIME", 'datetime');
_defineProperty(NewTableColumnTypes, "LOCAL_TIME", 'localtime');
export default NewTableColumnTypes;
//# sourceMappingURL=NewTableColumnTypes.js.map